import React, { Component } from "react"
import { observer, action, observable } from "mobx"
import { Link } from "react-router"

import shop from "shop/shop"
import app from "app.controller"

import "./TopNavigation.scss"

export default class TopNavigation extends Component {

  state = {
    menu:    false,
    current: false
  }

  componentDidMount() {
    app.language.changed.add( this.load )
    this.load()
  }

  load = () => {
    fetch( "https://shop.mags-vertrieb.de/wp/wp-json/acf/v3/menu?fields[name]=menu-en&lang=" + app._currentLanguage )
      .then( res => res.json() )
      .then( menus => menus[ 0 ] )
      .then( ( layout ) => {
        this.setState( { menu: layout.acf.menu } )
      } )
  }

  componentWillUnmount() {
    app.language.changed.remove( this.load )
  }

  show = entry => {
    this.setState( { current: entry } )
  }

  hide = entry => {
    this.setState( { current: false } )
  }

  render() {
    const { menu, current } = this.state
    const { session } = shop

    return (
      <div className="TopNavigation">
        <ul className="nav nav-main relative ">
          {menu && menu.map( entry => {
            if ( entry.login && !session ) return null
            return (
              <li className="level-0" key={entry.name} onMouseOver={() => {
                this.show( entry )
              }} onMouseOut={() => {
                this.hide( entry )
              }}>
                <Link className={entry.css}
                      to={entry.url || entry.image_url}>{entry.name}</Link>
                {/*{entry.links &&*/}
                {/*<div className={`dropdown ${current === entry && "active"}`}>*/}
                  {/*<div className="dropdown-inner">*/}
                    {/*{entry.image && entry.image_url &&*/}
                    {/*<Link className="nav-image" onClick={() => {*/}
                      {/*this.hide( entry )*/}
                    {/*}} to={entry.image_url}><img src={entry.image} width="250" className="fl "/></Link>}*/}
                    {/*{entry.image && !entry.image_url && <img src={entry.image} width="250" className="fl "/>}*/}
                    {/*<ul>*/}
                      {/*{entry.links.map( e => (<li key={`${entry.name}-${e.name}`}><Link className={e.css} onClick={() => {*/}
                        {/*this.hide( entry )*/}
                      {/*}} to={e.url}>{e.name}</Link></li>) )}*/}
                    {/*</ul>*/}
                  {/*</div>*/}
                {/*</div>}*/}
              </li>
            )
          } )}
        </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/TopNavigation.js